<app-management-sidemenu
  [(isOpen)]="isSideNavOpen"
  [managementType]="selectedManagementType"
  [actionType]="selectedActionType"
  (close)="isSideNavOpen = false"
  [selectedPoiCategoryRegion]="selectedPoiCategoryRegion"
  (refreshTable)="getPaginatedQuery()"
>
  <h1>{{ "poiCategoryRegionManagement" | localize }}</h1>
  <div
    class="poi-category-region-management-container custom-admin-label-class"
    [ngClass]="{
      'sidenav-open': isSideNavOpen,
      'sidenav-close': !isSideNavOpen
    }"
  >
    <div class="poi-category-region-management-header">
      <div class="poi-category-region-management-process">
        <button
          class="add-new-poi-category-region"
          style="cursor: pointer"
          (click)="
            openSideNav(ManagementType.PoiCategoryRegionManagement, ActionType.Create)
          "
        >
          <span> {{ "newPoiCategoryRegion" | localize }} </span>
          <img src="assets/icons/general/add-icon.png" alt="" />
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="table-container">
      <div class="table-responsive">
        <mat-table [dataSource]="dataSource">
          <!-- companyId Column -->
          <ng-container matColumnDef="companyId">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "company" | localize }}</mat-label>
                <input
                  [(ngModel)]="inputValues['companyId']"
                  matInput
                  (input)="onInputChange($event, 'companyId')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.companyId }}"
              matTooltipPosition="below"
            >
              {{ element.companyId || '-' }}
            </mat-cell>
          </ng-container>

          <!-- projectId Column -->
          <ng-container matColumnDef="projectId">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "project" | localize }}</mat-label>
                <input
                  [(ngModel)]="inputValues['projectId']"
                  matInput
                  (input)="onInputChange($event, 'projectId')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.projectId }}"
              matTooltipPosition="below"
            >
              {{ element.projectId || '-' }}
            </mat-cell>
          </ng-container>

          <!-- cityId Column -->
          <ng-container matColumnDef="cityId">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "city" | localize }}</mat-label>
                <input
                  [(ngModel)]="inputValues['cityId']"
                  matInput
                  (input)="onInputChange($event, 'cityId')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.cityId }}"
              matTooltipPosition="below"
            >
              {{ element.cityId || '-' }}
            </mat-cell>
          </ng-container>

          <!-- districtId Column -->
          <ng-container matColumnDef="districtId">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "district" | localize }}</mat-label>
                <input
                  [(ngModel)]="inputValues['districtId']"
                  matInput
                  (input)="onInputChange($event, 'districtId')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.districtId }}"
              matTooltipPosition="below"
            >
              {{ element.districtId || '-' }}
            </mat-cell>
          </ng-container>

          <!-- neighbourhoodId Column -->
          <ng-container matColumnDef="neighbourhoodId">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "neighbourhood" | localize }}</mat-label>
                <input
                  [(ngModel)]="inputValues['neighbourhoodId']"
                  matInput
                  (input)="onInputChange($event, 'neighbourhoodId')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.neighbourhoodId }}"
              matTooltipPosition="below"
            >
              {{ element.neighbourhoodId || '-' }}
            </mat-cell>
          </ng-container>

          <!-- isProcessed Column with Dropdown Filter -->
          <ng-container matColumnDef="isProcessed">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label title="{{ 'isProcessed' | localize }}">{{ "processedStatus" | localize }}</mat-label>
                <mat-select 
                  [(value)]="isProcessedFilter"
                  (selectionChange)="onIsProcessedFilterChange($event.value)"
                  [placeholder]="'all' | localize"
                >
                  <mat-option [value]="null">{{ "all" | localize }}</mat-option>
                  <mat-option [value]="true">{{ "yes" | localize }}</mat-option>
                  <mat-option [value]="false">{{ "no" | localize }}</mat-option>
                </mat-select>
              </mat-form-field>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="status-cell">
              <span *ngIf="element.isProcessed" class="active-label">{{ 'yes' | localize }}</span>
              <span *ngIf="!element.isProcessed" class="inactive-label">{{ 'no' | localize }}</span>
            </mat-cell>
          </ng-container>

          <!-- options Column -->
          <ng-container matColumnDef="options">
            <mat-header-cell class="options-column" *matHeaderCellDef>
              #
            </mat-header-cell>
            <mat-cell class="options-cell" *matCellDef="let element">
              <button
                mat-icon-button
                [matMenuTriggerFor]="actionMenu"
                aria-label="Options"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu class="options-menu" #actionMenu="matMenu">
                <div class="menu-header">{{ "transactions" | localize }}</div>
                <button
                  mat-menu-item
                  (click)="
                    openSideNav(
                      ManagementType.PoiCategoryRegionManagement,
                      ActionType.Update,
                      element
                    )
                  "
                >
                  <img
                    src="assets/icons/general/edit-project-icon.png"
                    alt=""
                  />
                  {{ "edit" | localize }}
                </button>

                <button mat-menu-item (click)="deletePoiCategoryRegion(element)">
                  <img
                    src="assets/icons/general/delete-project-icon.png"
                    alt=""
                  />
                  {{ "delete" | localize }}
                </button>
              </mat-menu>
            </mat-cell>
          </ng-container>

          <!-- Define rows -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          
          <!-- No Data Row -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center; padding: 20px; color: #777777;">
              {{ "noRecordsFound" | localize }}
            </td>
          </tr>
        </mat-table>
      </div>

      <!--Paginator-->
      <div class="custom-paginator">
        <span *ngIf="poiCategoryRegionSearchLength > 0; else noRecords">
          {{ poiCategoryRegionSearchLength }} {{ 'entries' | localize }} {{ currentPage * pageSize + 1 }} -
          {{ Math.min(poiCategoryRegionSearchLength, (currentPage + 1) * pageSize) }}
          {{ 'showing' | localize }}
        </span>
        <ng-template #noRecords>{{ "noRecordsFound" | localize }}</ng-template>

        <!-- Paginator Buttons -->
        <button (click)="onPageChange(0)" [disabled]="currentPage === 0">
          &laquo;
        </button>
        <button
          (click)="onPageChange(currentPage - 1)"
          [disabled]="currentPage === 0"
        >
          &lt;
        </button>
        <ng-container *ngFor="let page of visiblePageNumbers">
          <button
            [class.active]="page - 1 === currentPage"
            (click)="onPageChange(page - 1)"
          >
            {{ page }}
          </button>
        </ng-container>
        <button
          (click)="onPageChange(currentPage + 1)"
          [disabled]="currentPage >= totalPages - 1"
        >
          &gt;
        </button>
        <button
          (click)="onPageChange(totalPages - 1)"
          [disabled]="currentPage >= totalPages - 1"
        >
          &raquo;
        </button>
        <!--PageSize selection-->
        <select [(ngModel)]="pageSize" (change)="updatePageSize($event)">
          <option *ngFor="let option of [5, 10]" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>
</app-management-sidemenu>
